import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PartnerRoute = ({ component: Component }) => {
  const { user } = useAuth();

  if (user === undefined) {
    return <div>Chargement...</div>;
  }

  return user && user.role === "PARTNER" ? <Component /> : <Navigate to="/" />;
};

export default PartnerRoute;
